import React from 'react'
import ActiveItemDivider from './ActiveItemDivider'
import { usePopup } from 'hooks/usePopup';
import { useSoundPath } from 'hooks/useSoundPath';

const ActiveItemMakeOfferButton = () => {
  const setPopupHook = usePopup();
  const playSound = useSoundPath();

  const makeAnOfferHandler = () => {
    setPopupHook({type: 'make-offer'});
    playSound('main')
  }

  return (
    <>
      <div className="card-details__buttons">
        <button className="card-details__buy-now" onClick={makeAnOfferHandler}>Make an offer</button>
      </div>
      <ActiveItemDivider />
    </>
  )
}

export default ActiveItemMakeOfferButton
